'use client';

import { useEffect, useRef } from 'react';
import { buildUrlManager, UrlManager, UrlManagerState } from '@coveo/headless';
import { useCoveoEngine } from 'lib/utils/coveo/SearchContext/CoveoEngineContext';

const UrlManagerController = () => {
  const engine = useCoveoEngine();
  const urlManagerRef = useRef<UrlManager>();

  useEffect(() => {
    if (!engine) return;

    const fragment =
      typeof window !== 'undefined' && window.location.hash.length > 1
        ? window.location.hash.slice(1)
        : '';

    const urlManager = buildUrlManager(engine, {
      initialState: {
        fragment: fragment !== '' ? fragment : '',
      },
    });

    urlManagerRef.current = urlManager;

    //engine.executeFirstSearch();

    const unsubscribe = urlManager.subscribe(() => {
      const state: UrlManagerState = urlManager.state;
      // if (typeof window !== 'undefined') {
      //   window.history.replaceState(null, '', `#${state.fragment}`);
      // }
      if (typeof window !== 'undefined') {
        const url = new URL(window.location.href);

        // Remove unnecessary query param
        url.searchParams.delete('path');

        let cleanedFragment = state.fragment;

        // Extract current q value from fragment
        const fragmentQMatch = cleanedFragment.match(/(?:^|&)q=([^&]*)/);
        const fragmentQValue = fragmentQMatch ? decodeURIComponent(fragmentQMatch[1]) : '';

        // Sync fragment q=... to query param
        if (fragmentQValue && fragmentQValue.trim() !== '') {
          url.searchParams.set('q', fragmentQValue);
        } else {
          url.searchParams.delete('q');
        }

        // Remove q=... and cq=... from fragment
        cleanedFragment = cleanedFragment
          .replace(/(^|&)q=[^&]*(&|$)/, '$1') // remove q
          .replace(/(^|&)cq=[^&]*(&|$)/, '$1') // remove cq
          .replace(/^&+|&+$/g, '');

        // Clean leftover & at start or end
        cleanedFragment = cleanedFragment.replace(/^&+|&+$/g, '');

        // Apply cleaned fragment as hash
        url.hash = cleanedFragment ? `#${cleanedFragment}` : '';

        // Final browser update - only if URL actually changed
        const currentUrl = window.location.href;
        if (currentUrl !== url.toString()) {
          window.history.replaceState(null, '', url.toString());
        }
      }
    });

    //engine.executeFirstSearch(); // must come after urlManager is ready

    return () => {
      unsubscribe();
    };
  }, [engine]);

  return null;
};

export default UrlManagerController;
